<template>
    <div>
        <div class="games">
            <games-icon class="games__icon"></games-icon>
            <h2 class="games__title">
                Games hosted by me
            </h2>
        </div>
        <div class="summary-games-table">
            <Table
                :columns="columns"
                :data="
                    getGames && getGames.length > 0
                        ? getGames.slice(0, 3)
                        : null
                "
                :cell-style="
                    'display: grid; grid-template-columns: 3fr 2fr 2fr 2fr 0.7fr; grid-template-rows: 4rem;'
                "
                :data-elements="[
                    'name',
                    'currentPlayers',
                    'allServersCount',
                    'scenarioEarning',
                ]"
                :cropp="true"
                :cropp-no="10"
                :footer-elements="
                    getGames && getGames.length > 0
                        ? [
                              'Total',
                              `${totalCurrentPlayers}`,
                              `${allServersCount}`,
                              `${total_coyns_earned}`,
                          ]
                        : null
                "
                :is-loading="getLoading"
                :no-title="true"
            />
        </div>

        <button-default
            class="games-table__view-all"
            :color="'veryDarkBlue'"
            :style="veryDarkBlueButton"
            :link="ALL_MY_GAMES_PAGE_NAME"
            :component-nav="true"
            :svg="true"
            :text="'View All'"
            :name="'view_all_arrow'"
            :svg-style="'width: 12px; fill: white; margin: auto 2px;'"
        />
    </div>
</template>

<script>
import { ALL_MY_GAMES_PAGE_NAME } from '@/router/pageNameConstants.js';

import GamesIcon from 'Svgs/small_game_search.svg?inline';
import LoadingTable from '@/components/common/loading/LoadingTable';
import Button from '@/components/common/Button';
import { totalNumber } from '@/lib/calculations.js';
import { mapGetters, mapActions } from 'vuex';
import Table from '@/components/common/Table.vue';

export default {
    name: 'Games',
    components: { GamesIcon, LoadingTable, 'button-default': Button, Table },
    data() {
        return {
            ALL_MY_GAMES_PAGE_NAME,
            veryDarkBlueButton: {
                width: '94px',
                height: '29px',
                fontFamily: '$palanquin-font',
                fontSize: '13px',
                fontWeight: '400',
                letterSpacing: '0.05px',
                margin: '2rem 5rem auto auto',
            },
            columns: [
                'Game name',
                'Current Players',
                'Servers',
                'Coyns Earned',
            ],
        };
    },
    computed: {
        ...mapGetters('module_servers', {
            getLoading: 'getLoading',
            getGames: 'getGames',
            allServersCount: 'allServersCount',
            totalCurrentPlayers: 'totalCurrentPlayers',
        }),

        total_coyns_earned() {
            return totalNumber(this.getGames, 'scenarioEarning');
        },
    },
    created() {
        this.fetchServers();
    },
    methods: {
        totalNumber,
        ...mapActions('module_servers', ['fetchServers']),
    },
};
</script>

<style scoped lang="scss">
.games {
    display: grid;
    grid-template-columns: 4rem 20fr;
    grid-template-rows: auto;
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        grid-template-columns: 1fr 2fr;
    }

    &__icon {
        grid-column: 1;
        margin: -0.5rem auto 0.5rem 3.1rem;
        justify-self: end;

        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            display: none;
        }
    }

    &__title {
        margin: -0.5rem auto 0.5rem 1rem;
        color: $blue-main;
        font-family: $istok-font;
        font-size: 28px;
        font-weight: 700;
        letter-spacing: 0.44px;

        grid-column: 2;
        @media (min-width: 321px) and (max-width: $xs-up) {
            width: 320px;
            letter-spacing: 0.14px;
            text-align: center;
            font-size: 30px;
            grid-row: 1;
            grid-column: 1;
        }
        @media (max-width: $xxs-up) {
            width: 300px;
            letter-spacing: 0.14px;
            font-size: 25px;
            grid-row: 1;
            grid-column: 1;
            margin: 6px auto auto 1.1rem;
        }
    }
}
</style>
<style lang="scss">
.summary-games-table {
    margin: 1rem auto auto 3rem;
    width: 90%;

    @media (max-width: $xs-up) {
        margin: auto;
        width: 90%;
    }
    .generic-table {
        .cont {
            @media (max-width: $xs-up) {
                width: 700px;
            }
        }
    }
}

.my-overview-container {
    .svg {
        fill: white;
        width: 11px;
        height: 11px;
    }
}
</style>
